const getAuditMessagesSucessType = 'GET_AUDIT_MESSAGES_SUCESS';
const addAuditMessageSuccessType = 'ADD_AUDIT_MESSAGE_SUCCESS';

export {
    getAuditMessagesSucessType,
    addAuditMessageSuccessType
}